// src/App.js
import React from "react";
import QuranAcademyWebsite from "./pages/QuranAcademyWebsite";


function App() {
  return <QuranAcademyWebsite />;
}

export default App;
